import React from 'react'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useState } from 'react'
import { AuthContext } from '../../context/AuthContext'
import { useContext } from 'react'
import { useParams } from 'react-router'
import ENDPOINT from '../../context/EndPoint'
import axios from 'axios'
import DeleteIcon from '@mui/icons-material/Delete';
import SecurityHeaders from '../../context/SecurityHeaders'

const MockTestQuestions = ({ test_type }) => {
  const params = useParams();
  const course_url = params.course_url
  const test_code = params.test_code
  const { user } = useContext(AuthContext)

  const [info, setinfo] = useState(null);

  useEffect(() => {
    getQuizzes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getQuizzes = async () => {
    const data = new FormData()
    data.append("session", user.SessionId)
    data.append("course_url", course_url)
    data.append("test_code", test_code)
    data.append("test_type", test_type)
    const res = await axios.post(ENDPOINT + "admin-get-questions.php", data, SecurityHeaders)
    if (res) {
      if (res.data) {
        if (res.data.status === "success") {
          setposts(res.data.data)
        }
      }
    }
  };

  const [account, setaccount] = useState(null);
  const [role, setrole] = useState(null);

  const [question, setquestion] = useState(null)
  const [option1, setoption1] = useState(null)
  const [option2, setoption2] = useState(null)
  const [option3, setoption3] = useState(null)
  const [option4, setoption4] = useState(null)
  const [answer, setanswer] = useState(null)
  const [posts, setposts] = useState(null)
  const [allcomments, setallcomments] = useState(null)
  const [qno, setqno] = useState(null)

  const AddQuiz = async (e) => {
    e.preventDefault()
    const data = new FormData()
    data.append("question", question)
    data.append("option1", option1)
    data.append("option2", option2)
    data.append("option3", option3)
    data.append("option4", option4)
    data.append("answer", answer)
    data.append("session", user.SessionId)
    data.append("question_number", qno)
    data.append("test_code", test_code)
    data.append("course_url", course_url)
    const res = await axios.post(ENDPOINT + "admin-add-question.php", data, SecurityHeaders)
    if (res) {
      if (res.data.status === "success") {
        getQuizzes()
      }
    }
  }

  const DeleteQuiz = async ({ quiz_id }) => {
    const data = new FormData()
    data.append("id", quiz_id)
    data.append("session", user.SessionId)
    const res = await axios.post(ENDPOINT + "admin-delete-question.php", data, SecurityHeaders)
    if (res.data) {
      if (res.data.status === "success") {
        getQuizzes()
      }
    }
  }

  const [answer1, setanswer1] = useState(false)
  const [answer2, setanswer2] = useState(false)
  const [answer3, setanswer3] = useState(false)
  const [answer4, setanswer4] = useState(false)

  useEffect(() => {
    if (answer1) { setanswer("option1"); setanswer2(false); setanswer3(false); setanswer4(false) }
    if (answer2) { setanswer("option2"); setanswer1(false); setanswer3(false); setanswer4(false) }
    if (answer3) { setanswer("option3"); setanswer1(false); setanswer2(false); setanswer4(false) }
    if (answer4) { setanswer("option4"); setanswer1(false); setanswer2(false); setanswer3(false) }
  }, [answer1, answer2, answer3, answer4])

  useEffect(() => {
    getQuizzes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ---- clean design tokens ------------------------------------------
  const C = { ink: "#1f2937", blue: "#2563eb", muted: "#8a909c", green: "#16a34a" };
  const card = { background: "#fff", borderRadius: 12, border: "1px solid #e8eaed", boxShadow: "0 1px 2px rgba(16,24,40,.04)" };
  const label = { display: "block", fontSize: 12.5, fontWeight: 600, color: "#5b616e", marginBottom: 6 };
  const delBtn = { border: "none", background: "transparent", color: "#b42318", cursor: "pointer", padding: 4, lineHeight: 1 };

  const checks = { 1: answer1, 2: answer2, 3: answer3, 4: answer4 };
  const toggles = { 1: () => setanswer1(!answer1), 2: () => setanswer2(!answer2), 3: () => setanswer3(!answer3), 4: () => setanswer4(!answer4) };
  const setters = { 1: setoption1, 2: setoption2, 3: setoption3, 4: setoption4 };

  return (
    <>
      <style>{`
        .mq-input{outline:none;border:1px solid #d9dde3;border-radius:8px;padding:10px 12px;font-size:14px;width:100%;background:#fff;color:#1f2937;}
        .mq-input:focus{border-color:#2563eb;box-shadow:0 0 0 3px rgba(37,99,235,.12);}
        .mq-btn{transition:opacity .15s ease;} .mq-btn:hover:not(:disabled){opacity:.9;}
      `}</style>

      <div style={{ background: "#f7f8fa", minHeight: "100vh", padding: "24px" }}>
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3" style={{ gap: 10 }}>
          <div>
            <h4 style={{ margin: 0, fontWeight: 700, color: C.ink }}>Mock Test Questions</h4>
            <p style={{ margin: "4px 0 0", fontSize: 13.5, color: C.muted }}>Test code <b>#{test_code}</b> · {course_url}</p>
          </div>
        </div>

        <div className="row g-4">
          {/* questions list */}
          <div className="col-12 col-lg-7">
            <div style={{ ...card, padding: 18 }}>
              <h6 style={{ margin: 0, fontWeight: 700, color: C.ink, marginBottom: 14 }}>
                Questions <span style={{ color: C.muted, fontWeight: 500 }}>({posts ? posts.length : 0})</span>
              </h6>
              {posts && posts.length ? (
                posts.map((quiz, i) => (
                  <div key={quiz.id} style={{ border: "1px solid #eef1f6", borderRadius: 10, padding: 14, marginBottom: 12 }}>
                    <div className="d-flex justify-content-between align-items-start" style={{ gap: 10 }}>
                      <div style={{ fontWeight: 600, color: C.ink }}>{i + 1}. {quiz.question}</div>
                      <button type="button" className="mq-btn" style={delBtn} title="Delete question" onClick={() => DeleteQuiz({ quiz_id: quiz.id })}>
                        <DeleteIcon style={{ fontSize: 18 }} />
                      </button>
                    </div>
                    <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                      {[1, 2, 3, 4].map((n) => {
                        const opt = quiz["option" + n];
                        const correct = quiz.answer === ("option" + n);
                        return (
                          <div key={n} style={{ border: `1px solid ${correct ? C.green : "#e6e8ec"}`, background: correct ? "#eafff3" : "#fff", color: correct ? "#127a4a" : "#3a4658", borderRadius: 8, padding: "7px 10px", fontSize: 13.5 }}>
                            {opt}{correct ? "  ✓" : ""}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ color: C.muted, margin: 0 }}>No questions yet — add one on the right.</p>
              )}
            </div>
          </div>

          {/* add question */}
          <div className="col-12 col-lg-5">
            <div style={{ ...card, padding: 18 }}>
              <h6 style={{ margin: 0, fontWeight: 700, color: C.ink, marginBottom: 14 }}>Add Question</h6>
              <form onSubmit={(e) => AddQuiz(e)}>
                <label style={label}>Question number</label>
                <input className="mq-input" type="number" onChange={(e) => setqno(e.target.value)} placeholder="e.g. 1" required />

                <label style={{ ...label, marginTop: 14 }}>Question</label>
                <textarea className="mq-input" rows={3} value={question || ""} onChange={(e) => setquestion(e.target.value)} placeholder="Enter the question" required style={{ resize: "vertical" }} />

                <label style={{ ...label, marginTop: 14 }}>Options <span style={{ color: C.muted, fontWeight: 500 }}>— tap “Mark correct” on the right answer</span></label>
                {[1, 2, 3, 4].map((n) => (
                  <div key={n} className="d-flex align-items-center" style={{ gap: 8, marginTop: 8 }}>
                    <input className="mq-input" onChange={(e) => setters[n](e.target.value)} placeholder={`Option ${n}`} required style={checks[n] ? { borderColor: C.green } : undefined} />
                    <button type="button" onClick={toggles[n]} className="mq-btn" style={{ whiteSpace: "nowrap", border: `1px solid ${checks[n] ? C.green : "#d9dde3"}`, background: checks[n] ? "#eafff3" : "#fff", color: checks[n] ? "#127a4a" : "#666", borderRadius: 8, padding: "9px 12px", fontSize: 12.5, fontWeight: 600, cursor: "pointer" }}>
                      {checks[n] ? "✓ Correct" : "Mark correct"}
                    </button>
                  </div>
                ))}

                <div style={{ marginTop: 14, fontSize: 13, fontWeight: 600, color: answer ? C.green : "#b42318" }}>
                  {answer ? `Correct answer: ${answer}` : "Select the correct option"}
                </div>

                <button type="submit" className="mq-btn" style={{ width: "100%", marginTop: 14, border: "none", color: "#fff", background: C.blue, borderRadius: 8, padding: "12px", fontSize: 14.5, fontWeight: 600, cursor: "pointer" }}>
                  Add Question
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MockTestQuestions
